<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" ref="page" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppMain',
  computed: {
    ...mapState('app', ['visitedViews']),
    cachedViews() {
      const views = [
        ...this.visitedViews.map(view => view.name),
        'split-account',
        'enterprise-same-name-transfer',
      ];
      return views;
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped>
.app-main {
  position: relative;
  width: 100%;

  /* 50 = navbar  */
  min-height: calc(100vh - 50px);
  padding-bottom: 60px;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
